import React from 'react';
import { Box } from '@mui/material'; // <--- Added this import!

import Hero from '../components/Hero';
import Features from '../components/Features';
import Stats from '../components/Stats';
import HowItWorks from '../components/HowItWorks';
import SecuritySection from '../components/SecuritySection';
import ReserveSection from '../components/ReserveSection'; 
import CTA from '../components/CTA';

function Home() {
  return (
    <Box sx={{ backgroundColor: '#050505', overflowX: 'hidden' }}>
      {/* 1. The Cinematic Intro */}
      <Hero />
      
      {/* 2. Why Choose Us (Silver Cards) */}
      <Features />
      
      {/* 3. Elegant Numbers */}
      <Stats />
      
      {/* 4. The 3-Step Process */}
      <HowItWorks />
      
      {/* 5. Institutional Trust */}
      <SecuritySection />
      
      {/* 6. The Parallax Background (Exclusivity) */}
      <ReserveSection />
      
      {/* 7. Final Private Call-to-Action */}
      <CTA />
    </Box>
  );
}

export default Home;